module.exports = __webpack_public_path__ + "static/loading-c8dcada56f08211c43e6ba5a6045bf2e.gif";